import TppBorrowModal from './TppBorrowModal';
import TppChargeModal from './TppChargeModal';
import TppReturnModal from './TppReturnModal';
import type {
  TppBorrowSubmitPayload,
  TppChargeSubmitPayload,
  TppReturnSubmitPayload,
} from './tppOpsModalTypes';

type Props = {
  closeLabel: string;
  money: (n: number) => string;
  zeroBalanceLabel: string;
  balanceNumber: number | null;
  isCheckedOut: boolean;
  otherCheckedOutCount?: number;
  returnRouteSeed: string;
  borrowOpen: boolean;
  onBorrowHide: () => void;
  borrowPending: boolean;
  onBorrowSubmit: (payload: TppBorrowSubmitPayload) => void;
  returnOpen: boolean;
  onReturnHide: () => void;
  returnPending: boolean;
  onReturnSubmit: (payload: TppReturnSubmitPayload) => void;
  chargeOpen: boolean;
  onChargeHide: () => void;
  chargePending: boolean;
  onChargeSubmit: (payload: TppChargeSubmitPayload) => void;
};

/** 貸出・返却・チャージ（開いているものだけマウントして autofocus 競合を避ける） */
export default function TppOpsModals({
  closeLabel,
  money,
  zeroBalanceLabel,
  balanceNumber,
  isCheckedOut,
  otherCheckedOutCount = 0,
  returnRouteSeed,
  borrowOpen,
  onBorrowHide,
  borrowPending,
  onBorrowSubmit,
  returnOpen,
  onReturnHide,
  returnPending,
  onReturnSubmit,
  chargeOpen,
  onChargeHide,
  chargePending,
  onChargeSubmit,
}: Props) {
  return (
    <>
      {borrowOpen ? (
        <TppBorrowModal
          show
          onHide={onBorrowHide}
          closeLabel={closeLabel}
          money={money}
          balanceNumber={balanceNumber}
          otherCheckedOutCount={otherCheckedOutCount}
          pending={borrowPending}
          onSubmit={onBorrowSubmit}
        />
      ) : null}
      {returnOpen ? (
        <TppReturnModal
          show
          onHide={onReturnHide}
          closeLabel={closeLabel}
          money={money}
          zeroBalanceLabel={zeroBalanceLabel}
          balanceNumber={balanceNumber}
          returnRouteSeed={returnRouteSeed}
          pending={returnPending}
          onSubmit={onReturnSubmit}
        />
      ) : null}
      {chargeOpen ? (
        <TppChargeModal
          show
          onHide={onChargeHide}
          closeLabel={closeLabel}
          money={money}
          balanceNumber={balanceNumber}
          isCheckedOut={isCheckedOut}
          pending={chargePending}
          onSubmit={onChargeSubmit}
        />
      ) : null}
    </>
  );
}
